import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@ortho-next/auth-core';
import { SseService } from '@ortho-next/sse';
import { filter, firstValueFrom } from 'rxjs';
import { APP_CONFIGURATION_TOKEN, AppConfiguration, LanguageService, MonitoringService } from './core';
import { CookieBannerService, UserService } from './services';
import { ConfirmationComponent } from './shared';


@Component({
	selector: 'app-root',
	imports: [
		RouterOutlet
	],
	templateUrl: './app.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class AppComponent implements OnInit {

	constructor(
		private readonly titleSrv: Title,
		private readonly langSrv: LanguageService,
		private readonly authSrv: AuthService,
		private readonly monitoringSrv: MonitoringService,
		private readonly sseSrv: SseService,
		private readonly cookieBannerSrv: CookieBannerService,
		private readonly userSrv: UserService,
		private readonly modalSrv: NgbModal,
		@Inject(APP_CONFIGURATION_TOKEN) private readonly configs: AppConfiguration
	) {
		authSrv.isDoneLoading$.subscribe(() => {
			if (authSrv.hasValidToken()) {
				sseSrv.connection(configs.sseAPI, () => firstValueFrom(authSrv.getAccessToken()));

				const userName = authSrv.userName;
				if (userName) {
					monitoringSrv.setAuthenticatedUserId(userName);
				}
			}
		});
		authSrv.onLogout$.subscribe(() => monitoringSrv.clearAuthenticatedUserId());
	}

	ngOnInit(): void {
		this.titleSrv.setTitle(this.langSrv.labels().APP_MAIN_TITLE);
		this.cookieBannerSrv.openBanner();
		this.userSrv.isMyHexPlan().pipe(
			filter(res => !res)
		).subscribe(() => this._openInvalidUserModal());
	}

	private _openInvalidUserModal(): void {
		const modalRef = this.modalSrv.open(ConfirmationComponent, { centered: true, backdrop: 'static' });
		(modalRef.componentInstance as ConfirmationComponent).config = {
			title: this.langSrv.labels().USER_UNAUTHORIZED_MODAL_TITLE,
			message: this.langSrv.labels().USER_UNAUTHORIZED_MODAL_MESSAGE,
			confirmBtn: this.langSrv.labels().USER_UNAUTHORIZED_MODAL_CONFIRM_BTN,
			isCancelBtn: false
		};
		modalRef.result.then(() => window.location.href = this.configs.patientSite);
	}
}
